import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.module.scss';

const LabelInput = ({label, bold = true}) => (
  <span className={classnames(styles.label, {[styles.bold]: bold})}>
    {label}
  </span>
);

LabelInput.propTypes = {
  label: PropTypes.node,
  bold: PropTypes.bool,
};

export default LabelInput;
